<template>
    <Toaster />
    <div
        class="slt-max-content-center slt-padding-box w-full pt-[112px] sm:pt-[128px] lg:px-[unset] lg:pt-[172px]"
        v-if="shouldRender(data)"
    >
        <div
            class="flex items-center justify-between lg:mx-auto lg:max-w-[948px]"
        >
            <!-- TEMP: 一篇新聞只能顯示一個分類設計(無分類則顯示預設值) -->
            <AtomsTag
                lg
                :html="
                    data?.type === 'news'
                        ? data?.['news-category']?.[0] ||
                          $t('news.post.type.news')
                        : data?.['award-category']?.[0] ||
                          $t('news.post.type.awards')
                "
            ></AtomsTag>

            <div class="slt-flex-center gap-2 text-base-black-60">
                <NuxtLink
                    :to="$localePath('/')"
                    v-sendGAsignal="{
                        event_category: '麵包屑',
                        event_label: '返回首頁',
                    }"
                >
                    <AtomsBody1>
                        {{ t("breadcrumb.home") }}
                    </AtomsBody1>
                </NuxtLink>
                <div class="h-1 w-1 rounded-full bg-base-black-60" />
                <NuxtLink
                    :to="
                        $localePath(data?.type === 'news' ? '/news' : '/awards')
                    "
                    v-sendGAsignal="{
                        event_category: '麵包屑',
                        event_label:
                            data?.type === 'news'
                                ? '返回橘子動態'
                                : '返回獲獎紀錄',
                    }"
                >
                    <AtomsBody1>
                        {{
                            data?.type === "news"
                                ? t("breadcrumb.news")
                                : t("breadcrumb.awards")
                        }}
                    </AtomsBody1>
                </NuxtLink>
            </div>
        </div>

        <article
            class="slt-flex-center mt-6 flex-col gap-8 text-base-black sm:mt-8 sm:gap-10 lg:mx-auto lg:mt-10 lg:max-w-[948px]"
        >
            <div class="flex w-full flex-col gap-4 px-2 lg:gap-6">
                <AtomsH5
                    lang="en"
                    class="px-1 text-left text-base-black-60"
                    v-if="shouldRender(data?.date)"
                >
                    {{ formatDate(data?.date) }}
                </AtomsH5>
                <AtomsH1 v-if="shouldRender(data?.meta_box?.customTitle)">
                    {{ renderLines(data?.meta_box?.customTitle) }}
                </AtomsH1>
            </div>
            <OrganismsShareButtons isMobile />
            <div
                :class="
                    twMerge(
                        'relative w-full overflow-hidden rounded-[24px]',
                        (data?.meta_box?.customImage?.mobileImage?.source_url ||
                            data?.meta_box?.customImage?.tabletImage
                                ?.source_url) &&
                            'h-0  pt-[137.4%] sm:pt-[52.32%]',
                    )
                "
            >
                <AtomsResponsiveImg
                    :src="{
                        sm: data?.meta_box?.customImage?.mobileImage
                            ?.source_url,
                        md: data?.meta_box?.customImage?.tabletImage
                            ?.source_url,
                        lg: data?.featured_media?.source_url,
                    }"
                    :alt="data?.featured_media?.alt_text"
                    :width="data?.featured_media?.media_details?.width"
                    :height="data?.featured_media?.media_details?.height"
                    :class="
                        twMerge(
                            'h-auto w-full object-cover',
                            // If custom image is set, use constrain ratio
                            (data?.meta_box?.customImage?.mobileImage
                                ?.source_url ||
                                data?.meta_box?.customImage?.tabletImage
                                    ?.source_url) &&
                                'absolute inset-0 h-full',
                        )
                    "
                />
            </div>

            <div class="w-full">
                <template v-for="(c, i) in htmlContent" :key="i">
                    <component
                        v-if="
                            typeof c === 'object' &&
                            c !== null &&
                            c['__v_isVNode']
                        "
                        :is="c"
                    />
                    <template v-else>{{ c }}</template>
                </template>
            </div>
        </article>
        <div
            :class="
                twMerge(
                    'px-4 pt-5 text-base-black-60 lg:mx-auto lg:max-w-[948px]',
                    !shouldRender(
                        data[
                            `${data?.type === 'news' ? 'news' : 'award'}-taxonomy`
                        ],
                    ) && 'lg:hidden',
                    !(relatedPosts.next || relatedPosts.previous) &&
                        'pb-[68px] sm:pb-[6.25rem] lg:pb-[unset]',
                )
            "
        >
            <OrganismsShareButtons isMobile />
            <AtomsBody1
                class="mt-10"
                v-if="
                    shouldRender(
                        data[
                            `${data?.type === 'news' ? 'news' : 'award'}-taxonomy`
                        ],
                    )
                "
            >
                {{
                    data[`${data?.type === "news" ? "news" : "award"}-taxonomy`]
                        .map((item) => `#${item}`)
                        .join(" ")
                }}
            </AtomsBody1>
        </div>
        <OrganismsShareButtons />
    </div>
    <!-- If no post, show no post message and fast link -->
    <OrganismsPostNotFound v-else />
    <div
        v-if="relatedPosts.next || relatedPosts.previous"
        class="mt-[68px] w-full bg-base-silver text-base-black sm:mt-[6.25rem] lg:mt-[calc(10rem-235px)]"
    >
        <div
            class="slt-max-content-center slt-padding-box sm:direction-rtl grid grid-cols-1 grid-rows-2 gap-20 py-16 has-[:only-child]:grid-rows-1 sm:grid-cols-2 sm:grid-rows-1 sm:gap-10 lg:gap-32 lg:py-36"
        >
            <template v-for="(post, key) in relatedPosts" :key="key">
                <MoleculesPostJump
                    v-if="post"
                    :post="post"
                    :type="key === 'next' ? 'next' : 'prev'"
                    :class="
                        key === 'next'
                            ? 'sm:col-start-2 sm:row-start-1'
                            : 'sm:col-start-1 sm:row-start-1'
                    "
                />
            </template>
        </div>
    </div>
</template>

<script setup>
import "vue-sonner/style.css";
import { twMerge } from "tailwind-merge";

const props = defineProps({
    data: {
        type: Object,
        required: true,
    },
});

// Check if data is valid, otherwise throw 404
if (!props.data || Object.keys(props.data).length === 0) {
    throw createError({
        statusCode: 404,
        statusMessage: "Page Not Found",
        fatal: true,
    });
}

import {
    renderWpContent,
    formatDate,
    renderLines,
    shouldRender,
} from "~/lib/utils";
const { t, locale } = useI18n();
const { fetchRelatedPosts } = useFetchAPI();
const { data: relatedPosts } = await fetchRelatedPosts(props.data?.id);

// Auto-redirect to correct language version if needed
if (props.data?.languageAlternatives && props.data.language !== locale.value) {
    const targetLanguagePost = props.data.languageAlternatives[locale.value];
    if (targetLanguagePost) {
        // Redirect to the correct language version
        await navigateTo(targetLanguagePost.url);
    }
}

// Watch for locale changes and redirect accordingly
watch(
    locale,
    async (newLocale) => {
        if (
            props.data?.languageAlternatives &&
            props.data.language !== newLocale
        ) {
            const targetLanguagePost =
                props.data.languageAlternatives[newLocale];
            if (targetLanguagePost) {
                await navigateTo(targetLanguagePost.url);
            }
        }
    },
    { immediate: false },
);

// Needed styles for WYSIWYG version
// useHead({
//     link: [
//         {
//             rel: "stylesheet",
//             // href: "/wordpress/wp-json/wordpress-export-css/wordpress-export-css.css",
//             href: "https://gamania-official-website.salute.gallery/wordpress/wp-json/wordpress-export-css/wordpress-export-css.css",
//         },
//         {
//             rel: "stylesheet",
//             // href: "/wordpress/wp-includes/css/dist/block-library/style.css",
//             href: "https://gamania-official-website.salute.gallery/wordpress/wp-includes/css/dist/block-library/style.css",
//         },
//         {
//             rel: "stylesheet",
//             // href: "/wp-includes/css/dist/block-library/theme.css",
//             href: "https://gamania-official-website.salute.gallery/wp-includes/css/dist/block-library/theme.css",
//         },
//     ],
// });
const htmlContent = renderWpContent(props.data?.meta_box?.htmlContent);
</script>
